import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const CLASSES = 'tw:border-0 tw:bg-transparent tw:text-left tw:rounded! '
  + 'tw:px-2 tw:py-1.5 tw:text-md tw:font-medium '
  + 'tw:text-gray-500 '
  + 'tw:hover:bg-gray-100 tw:hover:text-ds-neutral-highest '
  + 'tw:focus-visible:bg-gray-100 tw:focus-visible:text-ds-neutral-highest'

const PresetButton = ({ preset, onSelect }) => {
  const handleClick = useCallback(() => onSelect(preset), [preset, onSelect])

  return (
    <button className={CLASSES} type="button" onClick={handleClick}>
      {preset.label}
    </button>
  )
}

PresetButton.propTypes = {
  onSelect: PropTypes.func.isRequired,
  preset: PropTypes.shape({
    label: PropTypes.string.isRequired,
    getRange: PropTypes.func.isRequired
  }).isRequired
}

export default PresetButton
